/*
 * RouteControls Messages
 *
 * This contains all the text for the RouteControls component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  showRoutes: {
    id: 'app.components.RouteControls.showRoutes',
    defaultMessage: 'Show routes',
  },
  onlyOwnRoutes: {
    id: 'app.components.RouteControls.onlyOwnRoutes',
    defaultMessage: 'Only own routes',
  },
  distanceFilter: {
    id: 'app.components.RouteControls.distanceFilter',
    defaultMessage: 'Filter by distance',
  },
  manageRoutes: {
    id: 'app.components.RouteControls.manageRoutes',
    defaultMessage: 'Manage routes',
  },
  disabled: {
    id: 'app.components.RouteControls.disabled',
    defaultMessage: 'Disabled when editing',
  },
  from: {
    id: 'app.components.RouteControls.from',
    defaultMessage: 'From',
  },
  to: {
    id: 'app.components.RouteControls.to',
    defaultMessage: 'to',
  },
});
